"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function rpx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.897 11.7989C19.437 11.7989 19.875 12.2264 19.875 12.7552C19.875 13.2839 19.437 13.7114 18.897 13.7114C18.4845 13.7114 18.1312 13.4609 17.988 13.1077H15.198L14.169 14.9377C13.9995 15.2392 13.5352 15.1499 13.4948 14.8087L13.2638 12.8534L12.4088 19.1939C12.3518 19.6154 11.721 19.5959 11.6918 19.1714L10.9905 8.9212L10.248 15.7117C10.203 16.1167 9.60825 16.1377 9.5355 15.7364L8.7495 11.4194L8.3865 12.8407C8.36606 12.9176 8.32064 12.9856 8.25738 13.0339C8.19412 13.0823 8.11661 13.1082 8.037 13.1077H4.485C4.28625 13.1077 4.125 12.9502 4.125 12.7552C4.125 12.5602 4.28625 12.4027 4.485 12.4027H7.755L8.45925 9.64945C8.55375 9.28045 9.09525 9.2992 9.16425 9.67345L9.801 13.1752L10.7153 4.81495C10.7625 4.3867 11.4038 4.3987 11.433 4.82845L12.1688 15.5834L12.9293 9.94045C12.9847 9.5287 13.596 9.5332 13.6448 9.9457L14.0812 13.6319L14.6693 12.5849C14.701 12.5293 14.747 12.4831 14.8025 12.4511C14.8579 12.4191 14.9209 12.4024 14.985 12.4027H17.988C18.0624 12.2231 18.1886 12.0698 18.3505 11.9623C18.5124 11.8547 18.7026 11.7979 18.897 11.7989Z", fill: color }));
}
exports["default"] = rpx;
//# sourceMappingURL=rpx.js.map